import Link from 'next/link';

import { ReactElement, useCallback } from 'react';

import { TABLET_WIDTH } from '@common/constants/MEDIAS';
import { css } from '@emotion/react';
import { SearchType } from '@type/web/event';

import { palette } from '@lib/styles/palette';

import Icon from '@components/common/Icon';

const navDetails = [
  {
    navType: SearchType.ING,
    navText: '진행중',
  },
  {
    navType: SearchType.END,
    navText: '종료',
  },
  {
    navType: SearchType.WINNERS,
    navText: '당첨자 발표',
  },
];

const checkIsActiveNav = (
  eventNavType: SearchType,
  navTypes: SearchType,
): boolean => eventNavType === navTypes;

interface EventNavPropsType {
  searchType: SearchType;
}

export default function EventNav({
  searchType,
}: EventNavPropsType): ReactElement {
  /** 네비게이터 이동시 스크롤 상단으로 이동 */
  const scrollTop = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div css={eventNavContainerStyle}>
      <h1 className="nav-title">이벤트</h1>
      <nav>
        <ul>
          {navDetails.map(({ navType, navText }) => {
            const isActiveNav = checkIsActiveNav(searchType, navType);

            return (
              <li key={navType}>
                <Link href={`/event/list?searchType=${navType}`}>
                  <a
                    className={[
                      'nav-link',
                      isActiveNav ? 'isActiveNav' : '',
                    ].join(' ')}
                    onClick={scrollTop}
                  >
                    {navText}
                    {isActiveNav && <Icon icon="checkItalic" />}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}

const eventNavContainerStyle = css`
  list-style: none;
  padding: 13px 20px;
  background-color: white;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: ${TABLET_WIDTH}) {
    .nav-title {
      font-size: 1.2rem;
      padding: 1.4rem 0 1.9rem;
      border-bottom: 1px solid ${palette.gray6};
    }
    .nav-title,
    .isActiveNav {
      color: ${palette.black10};
      font-weight: 500;
    }
    ul {
      display: flex;
      padding: 1.4rem 0;
      li {
        padding: 0 1.8rem 0 1rem;
        border-left: 1px solid ${palette.gray2};
      }
      li:first-of-type {
        padding-left: 0;
        border-left: none;
      }
      a {
        color: ${palette.gray6};
        position: relative;
      }
      svg {
        position: absolute;
        right: -1rem;
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    background-color: white;

    .nav-title {
      display: none;
    }

    li {
      margin-right: 8px;
    }

    ul {
      list-style: none;
      display: flex;
      padding: 13px 0px;
    }

    .nav-link {
      color: ${palette.gray5};
      padding: 10px 16px;
      border-radius: 32px;
      border: 1px solid ${palette.gray5};
    }

    .isActiveNav {
      color: ${palette.orange9};
      border: 1px solid ${palette.orange9};
    }

    svg {
      display: none;
    }
  }
`;
